import { IPrices } from '@rbi-ctg/menu';
import { IRestaurant } from '@rbi-ctg/store';
import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';

export interface IPreloadedStoreState {
  prices: IPrices;
  store: IRestaurant | null;
}

export const preloadedStoreInfo = () =>
  syncStorage.getObject<IPreloadedStoreState>(SyncStorageKey.STORE) || ({} as IPreloadedStoreState);
